import React, { useContext } from 'react';
import { BuildContext } from '../../Data/Context/buildData';
import { Link } from 'react-router-dom';

/**
 * 
 * @param classes Aditional classes
 * @param src Img src
 * @param alt Img Alt is required 
 */
const ImgSelect = ({ children, classes, src, alt, item, itemType, positive, negative }) => {
    const { updateBuild, updateAbility, updatePersonality, updateHeldItem, updateHiddenSkill, updateGear } = useContext(BuildContext) //Ponto 7 chamar o equivalente ao updatePersonality

    function onItemSelect(item) {
        if (itemType === 'ability') updateAbility(item)
        if (itemType === 'personality') updatePersonality(item)
        if (itemType === 'heldItem') updateHeldItem(item)
        if (itemType === 'gear') updateGear(item)
        if (itemType === 'hiddenSkill') updateHiddenSkill(item)
        updateBuild()
    }

    if (itemType === 'ability')
        return (
            <div className='text-center p-1'>
                <Link to="#">
                    <img loading="lazy" onClick={() => onItemSelect(item)} data-bs-dismiss="modal" data-bs-toggle="tooltip" data-bss-tooltip="" className={`${classes}`} src={src} title={alt} alt={alt}></img>
                    <p className='text-center itemDesc'><small>{children}</small></p>
                </Link>
            </div>
        );

    if (itemType === 'personality')
        return (
            <div className='text-center p-1 mb-4 personality-square' onClick={() => onItemSelect(item)} data-bs-dismiss="modal">
                <Link to="#">
                    {positive
                        ?
                        <>
                            <p id='positive'>+10% {positive}</p>
                            <p id='negative'>-10% {negative}</p>
                        </>
                        :
                        <>
                            <p id='negative' className='no-changes'>No changes</p>
                        </>
                    }

                    <img loading="lazy" className={`${classes}`} src={src} title={alt} alt={alt}></img>
                    <p className='text-center itemDesc'><small>{children}</small></p>
                </Link>
            </div>
        );

    if (itemType === 'heldItem')
        return (
            <div className='text-center p-1'>
                <Link to="#">
                    <img loading="lazy" onClick={() => onItemSelect(item)} data-bs-dismiss="modal" data-bs-toggle="tooltip" data-bss-tooltip="" className={`${classes}`} src={src} title={alt} alt={alt}></img>
                    <p className='text-center itemDesc'><small>{children}</small></p>
                </Link>
            </div>
        );

    if (itemType === 'gear')
        return (
            <div className='text-center p-1'>
                <Link to="#">
                    <img loading="lazy" onClick={() => onItemSelect(item)} data-bs-dismiss="modal" data-bs-toggle="tooltip" data-bss-tooltip="" className={`${classes}`} src={src} title={alt} alt={alt}></img>
                    <p className='text-center itemDesc'><small>{children}</small></p>
                </Link>
            </div>
        );

    if (itemType === 'hiddenSkill')//Ponto 8 Duplicar e modificar
        return (
            <div className='text-center p-1'>
                <Link to="#">
                    <img loading="lazy" onClick={() => onItemSelect(item)} data-bs-dismiss="modal" data-bs-toggle="tooltip" data-bss-tooltip="" className={`${classes}`} src={src} title={alt} alt={alt}></img>
                    <p className='text-center itemDesc'><small>{children}</small></p>
                </Link>
            </div>
        );

}
export default ImgSelect;